import React, { FC, Suspense } from 'react'
import { styled } from '@creditas/stylitas'
import { useNavigate, useLocation } from 'react-router-dom'

import { StatusFilter } from 'components/StatusFilter'

import { OrderBy } from '../OrderBy'
import { Tabs, TabItem } from '../Tab'
import { WorkflowDetails } from './WorkflowDetails'
import { Card } from './Card'
import { LeadInfoLoading } from './LeadInfo/Loading'
import { LoanInfoLoading } from './LoanInfo/Loading'
import { Dashboard } from './Dashboard'
import { ROUTES } from 'pages'

const ContentContainer = styled.div`
  flex: 1;
  min-width: auto;
`

const Content: FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const isDashboard = location.pathname === ROUTES.ASSIGNMENTS_DASHBOARD

  return (
    <ContentContainer>
      <Tabs>
        <TabItem
          variant={isDashboard ? undefined : 'selected'}
          onClick={() => {
            navigate(ROUTES.ASSIGNMENTS)
          }}
        >
          Minha carteira
        </TabItem>
        <TabItem
          variant={isDashboard ? 'selected' : undefined}
          onClick={() => {
            navigate(ROUTES.ASSIGNMENTS_DASHBOARD)
          }}
        >
          Dashboards
        </TabItem>
      </Tabs>
      {isDashboard ? (
        <Dashboard />
      ) : (
        <Suspense
          fallback={
            <>
              <StatusFilter />
              <OrderBy />
              {[0, 1, 2, 3, 4].map(id => (
                <Card key={id} loading>
                  <LeadInfoLoading />
                  <LoanInfoLoading />
                </Card>
              ))}
            </>
          }
        >
          <WorkflowDetails />
        </Suspense>
      )}
    </ContentContainer>
  )
}

export { Content }
